var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "#26B0EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6406 16.3604C41.8266 14.5465 38.8857 14.5465 37.0718 16.3604L34.3764 19.0559L40.9452 25.6246L43.6406 22.9292C45.4545 21.1153 45.4545 18.1744 43.6406 16.3604ZM39.8845 26.6853L33.3157 20.1165L17.9793 35.4529C17.045 36.3872 16.4133 37.5808 16.1663 38.8787L15.276 43.5557C15.144 44.2489 15.7521 44.857 16.4453 44.7251L21.1223 43.8347C22.4202 43.5877 23.6138 42.956 24.5481 42.0217L39.8845 26.6853Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.e2ab02ef8df5f72ed25212dee4df6873.svg";
export { ForwardRef as ReactComponent };